import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import FloorPlanPage from './pages/FloorPlanPage';
import TableDetailPage from './pages/TableDetailPage';
import NotificationsPage from './pages/NotificationsPage';
import MyShiftPage from './pages/MyShiftPage';
import CashPaymentPage from './pages/CashPaymentPage';
import LiveOrdersPage from './pages/LiveOrdersPage';
import KitchenDisplayPage from './pages/KitchenDisplayPage';
import ReservationsPage from './pages/ReservationsPage';
import StockTogglesPage from './pages/StockTogglesPage';
import PromotionsPage from './pages/PromotionsPage';
import StatsPage from './pages/StatsPage';
import QrCodesPage from './pages/QrCodesPage';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { session } = useAuth();
  if (!session) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <FloorPlanPage />
            </RequireAuth>
          }
        />
        <Route
          path="/table/:tableId"
          element={
            <RequireAuth>
              <TableDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="/notifications"
          element={
            <RequireAuth>
              <NotificationsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/shift"
          element={
            <RequireAuth>
              <MyShiftPage />
            </RequireAuth>
          }
        />
        <Route
          path="/cash/:tableId?"
          element={
            <RequireAuth>
              <CashPaymentPage />
            </RequireAuth>
          }
        />
        <Route
          path="/orders"
          element={
            <RequireAuth>
              <LiveOrdersPage />
            </RequireAuth>
          }
        />
        <Route
          path="/kds"
          element={
            <RequireAuth>
              <KitchenDisplayPage />
            </RequireAuth>
          }
        />
        <Route
          path="/tables/qr-codes"
          element={
            <RequireAuth>
              <QrCodesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/reservations"
          element={
            <RequireAuth>
              <ReservationsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/stock"
          element={
            <RequireAuth>
              <StockTogglesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/promotions"
          element={
            <RequireAuth>
              <PromotionsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/stats"
          element={
            <RequireAuth>
              <StatsPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
